import { SET_HS_POPUP_DETAILS } from '../actions';

export const hsPopupReducer = (state = {}, action) => {
  if (action.type == SET_HS_POPUP_DETAILS) {
    return action.payload;
  }
  return state;
};
